/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
// Constants
import { Color } from "../../constants";

export const useStyles = (props) => ({
    breadcrumbContainer: css({
        width: "fit-content",
        display: "inline-flex",
        alignItems: "center",
    }),
    breadcrumbStackContainer: css({
        display: "flex",
        alignItems: "center",
        "& svg": {
            width: 24,
            height: 24,
            color: Color.primary[300],
            marginRight: 8,
        },
    }),
    breadcrumbStackContainerLastOfType: css({
        display: "flex",
        alignItems: "center",
        "& svg": {
            width: 24,
            height: 24,
            color: Color.primary[500],
            marginRight: 8,
        },
    }),
    breadcrumbLabel: css({
        userSelect: "none",
        color: Color.neutral[400],
        transition: "all 0.3s ease",
        "&:hover": {
            color: Color.primary[600],
            transition: "all 0.3s ease",
        },
    }),
    breadcrumbChevronRight: css({
        marginTop: 3,
        marginLeft: 8,
        marginRight: 8,
        width: 24,
        height: 24,
        color: Color.neutral[400],
    }),
    breadcrumbTypographyHeader: css({
        userSelect: "none",
        color: Color.neutral[400],
        transition: "all 0.3s ease",
        "&:hover": {
            color: Color.primary[600],
            transition: "all 0.3s ease",
        },
        marginBottom: -6,
        marginLeft: 28,
    }),
});
